import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import { compose } from 'redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import style from './MapLegend.scss';
import SchoolPin from './SchoolPin';

const mapIconLegend = {
  zoneEligibility: 'District Schools',
  zonedSchoolEligibility: 'Zoned School',
  nyceecEligibility: 'NYCEEC',
  charterEligibility: 'Charter School',
  preKCenterEligibility: 'Pre-K Center',
  halfdayEligibility: 'Half Day Program',
  familyChildCareEligibility: 'Family Child Care Program',
  cityWalkEligibility: 'Citywide G&T',
  transferEligibility: 'Transfer School',
  infantEligibility: 'Infant & Toddler',
  multipleEligibilities: 'Multiple School Types',
  specializedEligibility: 'Specialized High School',
  d75Eligibility: 'D75 School',
  defaultEligibility: 'Other',
  affiliatedSchools: 'Affiliated Schools',
};

const messages = defineMessages({
  zonedschool: {
    id: 'legenditem.zonedschool',
    defaultMessage: 'Zoned School',
    description: 'Zoned School',
  },
  legend: {
    id: 'map.legends',
    defaultMessage: 'Map legends',
    description: 'Pop up map legends label',
  },
  affiliatedschools: {
    id: 'legenditem.affiliatedschools',
    defaultMessage: 'Affiliated Location',
    description: 'Affiliated Location',
  },
  nyceec: {
    id: 'legenditem.NYCEEC',
    defaultMessage: 'NYCEEC',
    description: 'NYCEEC',
  },
  districtschools: {
    id: 'legenditem.districtschools',
    defaultMessage: 'District Schools',
    description: 'DistrictSchools',
  },
  specializedhighschool: {
    id: 'legenditem.specializedhighschool',
    defaultMessage: 'Specialized High School',
    description: 'Specialized High School',
  },
  citywidegt: {
    id: 'legenditem.citywidegt',
    defaultMessage: 'Citywide G&T',
    description: 'Citywide G&T',
  },
  prekcenter: {
    id: 'legenditem.prekcenter',
    defaultMessage: 'Pre-K Center',
    description: 'Pre-K Center',
  },
  familychildcareprogram: {
    id: 'legenditem.familychildcareprogram',
    defaultMessage: 'Family Child Care Program',
    description: 'Family Child Care Program',
  },
  halfdayprogram: {
    id: 'legenditem.halfdayprogram',
    defaultMessage: 'Half Day Program',
    description: 'Half Day Program',
  },
  infanttoddler: {
    id: 'legenditem.infanttoddler',
    defaultMessage: 'Infant & Toddler',
    description: 'Infant & Toddler',
  },
  charterschool: {
    id: 'legenditem.charterschool',
    defaultMessage: 'Charter School',
    description: 'Charter School',
  },
  d75school: {
    id: 'legenditem.d75school',
    defaultMessage: 'D75 School',
    description: 'D75 School',
  },
  transferschool: {
    id: 'legenditem.transferschool',
    defaultMessage: 'Transfer School',
    description: 'Transfer School',
  },
  multipleschooltypes: {
    id: 'legenditem.multipleschooltypes',
    defaultMessage: 'Multiple School Types',
    description: 'Multiple School Types',
  },
  multipleschools: {
    id: 'legenditem.multipleschools',
    defaultMessage: 'Multiple Schools',
    description: 'Multiple Schools',
  },
});

class MapLegend extends Component {
  static propTypes = {
    markers: PropTypes.arrayOf(PropTypes.shape),
    mobile: PropTypes.bool,
    isRtl: PropTypes.bool,
  };

  static defaultProps = {
    markers: [],
    mobile: false,
    isRtl: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      legendVisible: true,
    };
  }

  toggleLegend = () => {
    this.setState(prevState => ({
      legendVisible: !prevState.legendVisible,
    }));
  };

  render() {
    const { markers, mobile, isRtl } = this.props;
    const { legendVisible } = this.state;
    const maplegends = [];
    markers.forEach(marker => {
      if (mapIconLegend[marker.icon]) {
        if (marker.popup) {
          if (!maplegends.some(y => y.icon === marker.icon)) {
            const legend = { icon: marker.icon };
            legend.displayname = mapIconLegend[marker.icon];
            legend.schoolcount = 1;
            maplegends.push(legend);
          }
        }
        if (marker.popups && marker.popups.length > 1) {
          if (!maplegends.some(y => y.icon === marker.icon && y.schoolcount > 1)) {
            maplegends.push({ icon: marker.icon, schoolcount: marker.popups.length, displayname: 'Multiple Schools' });
          }
          marker.popups.forEach(child => {
            if (!maplegends.some(y => y.icon === child.icon)) {
              maplegends.push({ icon: child.icon, schoolcount: 1, displayname: mapIconLegend[child.icon] });
            }
          });
        }
      }
    });
    // removing the legend for Others - default icon
    const indexOfOther = maplegends.findIndex(x => x.displayname === 'Other');
    if (indexOfOther > -1) {
      maplegends.splice(indexOfOther, 1);
    }
    if (maplegends.length <= 0) {
      return null;
    }
    return (
      <div
        className={`${style.legendcontainer} ${isRtl ? style.rtlContainer : style.ltrContainer}`}
        onClick={() => this.toggleLegend()}
        onKeyDown={event => {
          if (event.key === 'l') {
            this.toggleLegend();
          }
        }}
        role="button"
        tabIndex="0"
      >
        {mobile && (
          <div className={`${style.mobileLegendIcon} ${isRtl ? style.rtlIconContainer : style.ltrIconContainer}`}
          >
            <SchoolPin
              width={30}
              height={30}
              type="zoneEligibility"
              overwriteInnerShapeBy="None"
              onClick={() => {}}
            />
          </div>
        )}
        <div className={`${style.legendbackground} ${isRtl ? style.itemcontainerRtl : ''}`}>
          <div className={style.itemcontainer}>
            {!mobile && (
              <div className={style.itemicon}>
                <SchoolPin
                  width={20}
                  height={20}
                  type="zoneEligibility"
                  overwriteInnerShapeBy="None"
                  onClick={() => {}}
                />
              </div>
            )}
            {(!mobile || legendVisible) && (
              <div className={style.legendTitle}>
                <FormattedMessage {...messages.legend} />
              </div>
            )}
            {legendVisible && (
              <div className={style.closecontainer}>
                <button type="button"> &minus; </button>
              </div>
            )}
          </div>
          {legendVisible && <div />}
          <div>
            {legendVisible &&
              maplegends.map(legend => (
                <div key={legend.displayname}>
                  <div className={style.itemcontainer}>
                    <div className={style.itemicon}>
                      <SchoolPin
                        width={25}
                        height={25}
                        type={legend.icon}
                        overwriteInnerShapeBy={legend.schoolcount > 1 ? `number$$${legend.schoolcount}` : undefined}
                        onClick={() => {}}
                      />
                    </div>
                    <div className={style.legendItem}>
                      <LegendItem messageKey={legend.displayname} />
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }
}

function LegendItem({ messageKey }) {
  const message = messages[messageKey.toLowerCase().replace(/[\s&-]/g, '')];
  if (message) {
    return <FormattedMessage {...message} />;
  }
  return null;
}

LegendItem.propTypes = {
  messageKey: PropTypes.string,
};

LegendItem.defaultProps = {
  messageKey: '',
};

export default compose(withStyles(style))(MapLegend);
